import React, { useEffect, useMemo, useState } from "react";
import { GoogleMap, LoadScript, Marker, Polyline } from "@react-google-maps/api";
import { MAP_FALLBACK_CENTER, pointPosition } from "components/RoutePlot";

const ReportMapView = ({ mapInfo, overlayImg }) => {
  const [mapData, setMapData] = useState([]);
  const [assetImg, setAssetImg] = useState("");
  const carWidth = 30;
  const carHeight = 50;

  useEffect(() => {
    // Simulate fetching API data
    setMapData(mapInfo);
    setAssetImg(overlayImg);
  }, [mapInfo, overlayImg]);

  // Google Maps configuration
  const mapContainerStyle = {
    height: "500px",
    width: "100%",
  };

  const placed = useMemo(
    () => (mapData || []).map((point) => ({ point, position: pointPosition(point) })).filter((item) => item.position),
    [mapData]
  );
  const center = placed[0]?.position || MAP_FALLBACK_CENTER;
  const pathCoordinates = placed.map((item) => item.position);

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={15}>
        {/* Polyline to show the route */}
        <Polyline path={pathCoordinates} options={{ strokeColor: "blue" }} />

        {/* Map through mapData to create Markers */}
        {placed.map(({ point, position }, index) => {
          const direction = parseFloat(point.dirn) || 0; // Get direction as a number
          
          // Render markers for all positions, but only set the image for the last one
          return window.google ? (
            <Marker
              key={index}
              position={position}
              icon={{
                url: index === placed.length - 1 ? assetImg : "", 
                scaledSize: new window.google.maps.Size(carWidth, carHeight),
                rotation: direction,
              }}
              label={{
                color: "black",
                fontSize: "12px",
              }}
            />
          ) : null;
        })}
      </GoogleMap>
    </LoadScript>
  );
};

export default ReportMapView;
